import ConfirmPresenter from './ConfirmPresenter';
import DeletePresenter from './DeletePresenter';
import { Partner } from './Rating';
import { Error, Updated } from './Notice';
import ProfileUpdatePreviewDialog from './Account/ProfileUpdatePreviewDialog';
import AlreadyGotPartnerAccountDialog from './Account/AlreadyGotPartnerAccountDialog';
import PostcodeDialog from './Postcode/PostCodeDialog';
export { ConfirmPresenter, DeletePresenter };

export default {
  Rating: {
    Partner
  },
  Account: {
    ProfileUpdatePreviewDialog,
    AlreadyGotPartnerAccountDialog
  },
  Notice: {
    Error,
    Updated
  },
  Address: {
    PostcodeDialog
  }
};
